import makeStyles from '@material-ui/core/styles/makeStyles';

const buttonVisible = {
  opacity: 1,
  '& button': { visibility: 'visible' },
};

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
  },
  container: {
    overflowX: 'scroll',

    '&:not(.scrolling)': {
      scrollBehavior: 'smooth',
      scrollSnapType: 'x mandatory',
    },

    // Invisible scrollbar
    '-ms-overflow-style': 'none',
    'scrollbar-width': 'none',
    '&::-webkit-scrollbar': { display: 'none' },
  },
  swipe: {
    cursor: 'grab',
    '&.scrolling': {
      cursor: 'grabbing',
    },
  },
  item: {
    scrollSnapAlign: 'start',

    [theme.breakpoints.up('xs')]: {
      minWidth: ({ xs }) => `${100 / xs}%`,
      width: ({ xs }) => `${100 / xs}%`,
    },
    [theme.breakpoints.up('sm')]: {
      minWidth: ({ sm }) => `${100 / sm}%`,
      width: ({ sm }) => `${100 / sm}%`,
    },
    [theme.breakpoints.up('md')]: {
      minWidth: ({ md }) => `${100 / md}%`,
      width: ({ md }) => `${100 / md}%`,
    },
    [theme.breakpoints.up('lg')]: {
      minWidth: ({ lg }) => `${100 / lg}%`,
      width: ({ lg }) => `${100 / lg}%`,
    },
    [theme.breakpoints.up('xl')]: {
      minWidth: ({ xl }) => `${100 / xl}%`,
      width: ({ xl }) => `${100 / xl}%`,
    },
  },
  button: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',

    // Invisible till hover
    opacity: 0,
    transition: 'opacity 0.4s ease',

    '& button': {
      backgroundColor: theme.palette.action.disabled,
      color: theme.palette.background.default,

      visibility: 'hidden',
      transition: 'visibility 0.4s ease',

      '&:hover': {
        backgroundColor: theme.palette.action.active,
      },
    },
  },
  prev: {
    left: theme.spacing(1),
  },
  next: {
    right: theme.spacing(1),
  },
  // Nav shown (prev/nexT)
  showNavAlways: { '& $button': buttonVisible },
  showNavOnHover: { '&:hover': buttonVisible },
  showNavOnHoverAll: { '&:hover': { '& $button': buttonVisible } },
}));

export default useStyles;
